(function () {
    'use strict';

    angular
            .module('caloappApp')
            .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        // this function is called to redirect the user to the home screen depending
        // on the fact he is connected or not and on the roles he has
        vm.goHome = goHome;

        // this method redirects the user to the calories screen
        vm.goToMyCalories = goToMyCalories;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function goHome() {
            if (!vm.isAuthenticated()) {
                $state.go('home');
            } else {


                Principal.identity().then(function (account) {
                    vm.account = account;

                    if (vm.account) {

                        // case the user has the role ROLE_ADMIN or ROLE_USERS_MANAGER
                        // we redirect him to the users manager screen
                        if (vm.account.authorities.indexOf('ROLE_ADMIN') >= 0 || vm.account.authorities.indexOf('ROLE_USERS_MANAGER') >= 0) {
                            $state.go('user-management', null, {reload: true});
                        }
                        // else we will redirect him to the calories screen
                        else {
                            $state.go('user-calories', {'username': vm.account.login});
                        }

                    }

                });


            }
        }

        function goToMyCalories() {
            Principal.identity().then(function (account) {
                vm.account = account;

                if (vm.account) {

                    // case the user has the role ROLE_ADMIN or ROLE_USERS_MANAGER
                    // we redirect him to the users manager screen
                    if (vm.account.authorities.indexOf('ROLE_USER') >= 0) {
                        $state.go('user-calories', {'username': vm.account.login});
                    }

                }

            });
        }
    }
})();
